import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IProjectsState, projectsAdapter, projectsKey } from '@app/main/main-screen/store/projects/projects.state';

export const selectProjectsState = createFeatureSelector<IProjectsState>(projectsKey);

const { selectAll, selectEntities, selectIds, selectTotal } = projectsAdapter.getSelectors(selectProjectsState);

export const selectAllProjects = selectAll;
export const selectProjectEntities = selectEntities;
export const selectProjectIds = selectIds;
export const selectProjectsTotal = selectTotal;

export const selectProjectsLoading = createSelector(selectProjectsState, state => state.loading);

export const selectProjectsLoaded = createSelector(selectProjectsState, state => state.loaded);

export const selectProjectsError = createSelector(selectProjectsState, state => state.error);

export const selectProjectById = (projectId: string) =>
  createSelector(selectProjectEntities, entities => entities[projectId]);
